import {Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Article, Payment, PaymentMethod, Student} from '../../models/eventRequest';
import {PaymentService} from '../../_services/payment.service';
import * as moment from 'moment';

declare let $: any;

@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.css']
})
export class PaymentFormComponent implements OnInit, OnChanges {

  paymentForm = this.resetForm();

  @Input()
  iNavMobile = false;

  @Input()
  iStudent?: Student;

  @Input()
  iPaymentMethods: PaymentMethod[] = [];

  @Input()
  isRefund = false;

  @Output()
  oNewPayment: EventEmitter<Payment> = new EventEmitter();

  paymentSubmited = false;
  popupError = '';

  constructor(private fb:UntypedFormBuilder, private paymentService: PaymentService) {
  }

  onCreatePayment() {
    const payment = this.paymentForm?.value;
    // Définir le type selon isRefund
    payment.paymentType = this.isRefund ? 'REFUND' : 'PAYMENT';
    // Si c'est un remboursement, rendre le montant négatif
    if (this.isRefund && payment.amount > 0) {
      payment.amount = -payment.amount;
    }
    this.paymentService.createPayment(payment).subscribe(
      newPayment => {
        this.oNewPayment.emit(newPayment);
        this.paymentForm = this.resetForm();
        this.paymentSubmited = false;
        $('#newPaymentModal').modal('hide');
      },
      err => {
        this.popupError = err.error.message;
      }
    );
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Réinitialiser le formulaire quand isRefund change
    if (changes.isRefund && !changes.isRefund.firstChange) {
      this.paymentForm = this.resetForm();
    }
  }

  onAmountChange(): void {
    const currentAmount = this.paymentForm.get('amount')?.value;
    if (this.isRefund) {
      // Pour un remboursement, convertir en négatif si positif
      if (currentAmount && currentAmount > 0) {
        this.paymentForm.patchValue({ amount: -currentAmount }, { emitEvent: false });
      }
    } else {
      // Pour un paiement normal, convertir en positif si négatif
      if (currentAmount && currentAmount < 0) {
        this.paymentForm.patchValue({ amount: Math.abs(currentAmount) }, { emitEvent: false });
      }
    }
  }

  isPaymentSubmited(form: UntypedFormGroup) {
    this.paymentSubmited = true;
    this.paymentForm.controls.studentId.setValue(this.iStudent?.id);
  }

  private resetForm(): UntypedFormGroup {
    const amountValidators = this.isRefund
      ? [Validators.required, Validators.max(0)] // Remboursement : négatif ou zéro
      : [Validators.required, Validators.min(0.01)]; // Paiement : strictement positif

    return  this.fb.group({
      date: [moment(new Date()).format('YYYY-MM-DD'), Validators.required],
      studentId: [this.iStudent?.id, Validators.required],
      amount: [null, amountValidators],
      paymentMethod: [null, Validators.required],
      description: [null],
      paymentType: [this.isRefund ? 'REFUND' : 'PAYMENT']
    });
  }
}
